exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-left-enter-active,.slide-left-leave-active,.slide-right-enter-active,.slide-right-leave-active{transition-duration:.5s;transition-property:height,opacity,transform;transition-timing-function:cubic-bezier(.55,0,.1,1);overflow:hidden}.slide-left-enter,.slide-right-leave-active{opacity:0;transform:translate(2em)}.slide-left-leave-active,.slide-right-enter{opacity:0;transform:translate(-2em)}.header img{padding-top:8px;padding-bottom:10px}.footer{width:100%;background:#06c}.footer .texto{text-align:center;padding:13px 0;color:#fff}@media only screen and (max-width:600px){.breadcrumb{padding-left:0;padding-right:0}.content-btn{background:#bed730}header{border-bottom:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a4ccfde","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 418
// module chunks = 58